import { AnyAction } from 'redux';

export const REDUCER_NAME = 'formSubmit';

export const FORM_SUBMIT_START = 'FORM_SUBMIT_START';
export const FORM_SUBMIT_END = 'FORM_SUBMIT_END';

export const formSubmitStart = () => ({
	type: FORM_SUBMIT_START
});

export const formSubmitStop = () => ({
	type: FORM_SUBMIT_END
});

export type FormSubmitState = {
	formSubmitting: boolean;
};

export default (
	state: FormSubmitState = {
		formSubmitting: false
	},
	action: AnyAction
) => {
	switch (action.type) {
		case FORM_SUBMIT_START:
			return {
				formSubmitting: true
			};
		case FORM_SUBMIT_END:
			return {
				formSubmitting: false
			};
		default:
			return state;
	}
};
